import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap';

const AlertBar = (props) => {
	const { data, onDiscard } = props;
	// const [alerts, setAlerts] = useState([]);

	const renderAlerts = (localAlerts) => {
		if (localAlerts && localAlerts.items) {
			return localAlerts.items.map((item, idx) => (
				<Alert key={idx} variant={item.type} onClose={() => onDiscardAlert(item)} dismissible>
					{item.msg}
				</Alert>
			));
		} else {
			return null;
		}
	};
	const onDiscardAlert = (alert) => {
		try {
			onDiscard(alert);
		} catch (e) {
			console.error('onDiscardAlert', e);
		}
	};
	return renderAlerts(data)

};

AlertBar.propTypes = {
	// data: PropTypes.array.isRequired,
	data: PropTypes.object.isRequired,
	onDiscard: PropTypes.func.isRequired
};

export default AlertBar;
